let PackagesItem = [
    {
        workshopTitle: "A Pragmatic Angular Testing Strategy",
        photo: require("../img/w-ticket/Jaaidi.png").default,
        name: 'Younes Jaaidi',
        position: 'Google Developer Expert & Software Cook',
        logo: require("../img/workshops/Marmicode.png").default,
        workshopPrice: "297",
        ticketPrice: "165",
        discountPrice: "415",
        workshopLink: 'https://geekle.us/ticket/1669994120128x118463995291369470?page=angular&utm_source=geekle&utm_medium=landingpage',
    },
    {
        workshopTitle: "Angular Architectures with Runtime Modification",
        photo: require("../img/w-ticket/Zikes.png").default,
        name: 'Michael Egger-Zikes',
        position: 'Angular Trainer & Consultant',
        // logo: require("../img/workshops/ANGULARarchitects.png").default,
        workshopPrice: "299",
        ticketPrice: "165",
        discountPrice: "417",
        workshopLink: 'https://geekle.us/ticket/1671461910228x349525021313466400?page=angular&utm_source=geekle&utm_medium=landingpage',
    },
    {
        workshopTitle: "Angular Testing",
        photo: require("../img/w-ticket/Ludemann.png").default,
        name: 'Christian Lüdemann',
        position: 'Angular consultant and trainer @Lüdemann Consulting APS',
        // logo: require("../img/workshops/Marmicode.png").default,
        workshopPrice: "265",
        ticketPrice: "165",
        discountPrice: "387",
        workshopLink: 'https://geekle.us/ticket/1671554006584x812962885889687600?page=angular&utm_source=geekle&utm_medium=landingpage',
    },
    {
        workshopTitle: "Modern Developer Tools",
        photo: require("../img/w-ticket/Kuncevic.png").default,
        name: 'Aliaksei Kuncevic',
        position: 'CEO',
        logo: require("../img/workshops/AngularConsulting.png").default,
        workshopPrice: "219",
        ticketPrice: "165",
        discountPrice: "346",
        workshopLink: 'https://geekle.us/ticket/1671718044085x595691421203169300?page=angular&utm_source=geekle&utm_medium=landingpage',
    },
];

export default PackagesItem;
